import { memo, useMemo } from 'react';
import { BackgroundTransitionTemplateMock } from './types';

function MockTemplateImageRenderer({
  element,
  scale
}: {
  element: BackgroundTransitionTemplateMock['timeline']['segments'][0]['elements'][0];
  scale: number;
}) {
  const styles = useMemo(() => {
    const elementWidth = element.width || 0;
    const elementHeight = element.height || 0;
    const elementX = element.x || 0;
    const elementY = element.y || 0;
    const elementRotation = element.rotation || 0;
    const elementCropX = element.cropX || 0;
    const elementCropY = element.cropY || 0;
    const elementCropWidth = element.cropWidth || 0;
    const elementCropHeight = element.cropHeight || 0;

    return {
      width: `${elementWidth * scale}px`,
      height: `${elementHeight * scale}px`,
      top: `${elementY * scale}px`,
      left: `${elementX * scale}px`,
      transform: `rotate(${elementRotation}deg)`,
      clipPath: `inset(${elementCropY * scale}px ${
        elementWidth * scale - (elementCropX * scale + elementCropWidth * scale)
      }px ${elementHeight * scale - (elementCropY * scale + elementCropHeight * scale)}px ${elementCropX * scale}px)`
    } as React.CSSProperties;
  }, [element, scale]);

  return (
    <div className="absolute" style={styles}>
      <img src={element.src} alt="speaker" className="h-full w-full object-cover" />
    </div>
  );
}

export default memo(MockTemplateImageRenderer);
